export enum AnalyticsActions {
    Click = 'click',
    Visit = 'visit',
    Leave = 'leave',
    Custom = 'custom',
    LoadNextPage = 'load-next-page',
    Scroll = 'scroll',
    ShowLoading = 'show-loading',
    HideLoading = 'hide-loading',
    Change = 'change',
    Seen = 'seen',
    Reveal = 'reveal',
    Error = 'error',
    Hover = 'hover',
    Swipe = 'swipe',
    Close = 'close',
    AnalyticsEvent = 'analyticsEvent',
}
